<template>
	<div
		:class="['panel', 'advices',
			isHeaderIndent? 'mt-0 pt-1' : '',
			isFooterIndent? 'mb-0 pb-1' : '',
			block.appearance? block.appearance : ''
		]"
	>
		<div class="container">
			<div
				v-if="isHeaderVisible"
				:class="[
					'panel_header',
					isBrand? 'sk' : '',
				]"
			>
				<div class="row align-items-end">
					<div class="col-12">
						<h2 v-if="block.block_title === null">
							Рекомендуем
						</h2>
						<h2 v-else>
							{{ block.block_title }}
						</h2>
					</div>
				</div>
			</div>
			<div class="advices_block">
				<ul class="advices_list row">
					<li v-for="(item, index) in content" :key="index" class="col-12 col-md-6 col-lg-3">
						<div class="advice-item">
							<div>
								<nuxt-link
									:to="$url.media(item.slug, item.taxonomy_type_slug,
										'typology' in fetchedData ? {
											query: { eventId: fetchedData.id }
										} : {},
										item.lang
									)"
								>
									<b-img-lazy
										:src="item.listing_cover_small_blocks_url"
										:alt="item.title"
									/>
								</nuxt-link>
								<div class="date">
									{{ item.date | moment("DD MMMM YYYY") }}
								</div>
								<nuxt-link
									:to="$url.media(item.slug, item.taxonomy_type_slug,
										'typology' in fetchedData ? {
											query: { eventId: fetchedData.id }
										} : {},
										item.lang
									)"
									class="title"
								>
									{{ item.title }}
								</nuxt-link>
							</div>
							<div class="advice-item_bottom">
								<nuxt-link
									:to="$url.media(item.slug, item.taxonomy_type_slug,
										'typology' in fetchedData ? {
											query: { eventId: fetchedData.id }
										} : {},
										item.lang
									)"
									class="more_link"
								>
									{{ contentTypeMap[item.content_type] }}
								</nuxt-link>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div v-if="isFooterVisible" class="panel_footer">
				<div class="row">
					<div class="col-12 col-sm-8">
						<nuxt-link
							to="/media/"
							class="btn btn-primary"
						>
							{{ $t('moreNews') }}
						</nuxt-link>
					</div>
					<div class="col-12 col-sm-4">
						<div class="panel_footer_info" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '@/utils/moment';
import panel from '@/mixins/panel';
import { BImgLazy } from 'bootstrap-vue';

export default {
	name: 'GraduateTips',
	components: {
		BImgLazy,
	},
	mixins: [panel],
	props: ['content', 'block_title'],
	data() {
		return {
			contentTypeMap: {
				0: this.$t('read'),
				1: this.$t('watch'),
				2: this.$t('listen'),
				3: this.$t('read'),
				4: this.$t('read'),
				5: this.$t('read'),
			},
		};
	},
};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/blocks/issue-graduate-tips";
</style>
